import { render } from "./Slide6.vue?vue&type=template&id=0430c2b2"
import script from "./Slide6.vue?vue&type=script&lang=js"
export * from "./Slide6.vue?vue&type=script&lang=js"

import "./Slide6.vue?vue&type=style&index=0&id=0430c2b2&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__